import { encryptionConfig } from './init.js';

async function encryptUserID(
/** User object or ID */
user) {
  const isUserID = typeof user === 'string';
  if (!encryptionConfig) throw Error(`Encryption not initialized when encrypting user${isUserID ? 'ID' : ''}`);
  return isUserID ? encryptionConfig.encryptData(user, [{
    userID: user
  }]) : encryptionConfig.encryptData(user.id, [{
    userID: user.id
  }]);
}

export { encryptUserID };
